module.exports = __webpack_public_path__ + "ollie_office-28e8e53f.jpg";